import React from 'react';

const LoadinContext = React.createContext({ bool: false, label: "Validando información, espere por favor" });

export default LoadinContext;